import React, { useRef, useEffect } from 'react';
import styled from 'styled-components';
import { Modal, Button, BREAKPOINTS } from '@awesomecomponents/mux';
import { BUTTON_VARIANT } from '@awesomecomponents/mux/core/components/Button';
import useFetch from '../utils/useFetch';
import { appConstants } from '../utils/appConstants';
import { bffRoutes } from '../utils/configuration';
import { removeAuth } from '../utils/authFunctions';
import { useHistory } from 'react-router-dom';

const ModalHeading = styled.p`
  font-size: 16px;
  font-weight: 600;
  line-height: 1.5;
  margin: 0 0 8px 0;

  @media (max-width: ${BREAKPOINTS.MAX_768}px) {
    margin: 14px 0 20px 0;
    text-align: left;
  }
`;

const ModalContent = styled.p`
  font-size: 16px;
  font-weight: 300;
  line-height: 1.5;
  margin-bottom: 20px;
  white-space: pre-wrap;

  @media (max-width: ${BREAKPOINTS.MAX_768}px) {
    margin: 0 0 30px 0;
    text-align: left;
  }
`;
const ButtonWrapper = styled.div`
  display: flex;
  justify-content: space-around;
  margin: 0 0 5px 0;

  @media (max-width: ${BREAKPOINTS.MAX_768}px) {
    margin: 0;
  }
`;

const ExitModal = ({
  isExitModalOpen,
  onExitModalCloseHandler,
  lang,
  langContent,
  isAuthenticated,
  setIsAuthenticated,
  setIsExitModalOpen,
}) => {
  const modalRef = useRef(null);
  const { LOGOUT_ROUTE, PUBLIC_LOGOUT_ROUTE, LOGOUT } = appConstants;
  const history = useHistory();
  const { HEADER, CONTENT_WITH_AUTH, CONTENT_WITHOUT_AUTH, BUTTON_CANCEL, BUTTON_EXIT } = langContent;

  //init fetch hook
  // getdata to make new api call.
  const { data, getData } = useFetch({ result: null, isLoading: false, error: null });
  /**
   * Set focus on modal for accessiblity.
   */
  useEffect(() => {
    if (isExitModalOpen) {
      modalRef.current.focus();
    }
  }, [isExitModalOpen]);

  useEffect(() => {
    //this efflect runs when 200 repsonse comes back from server.
    if (data.result && !data.isLoading && !data.error) {
      if (isAuthenticated) {
        removeAuth();
        setIsAuthenticated(false);
        history.push(LOGOUT_ROUTE, { requestPage: LOGOUT, language: lang });
      } else {
        history.push(PUBLIC_LOGOUT_ROUTE, { requestPage: LOGOUT, language: lang });
      }
      setIsExitModalOpen(false);
    } // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    data,
    isAuthenticated,
    setIsAuthenticated,
    setIsExitModalOpen,
    history,
    LOGOUT_ROUTE,
    PUBLIC_LOGOUT_ROUTE,
    LOGOUT,
  ]);

  return (
    <div ref={modalRef}>
      <Modal
        id="exitModal"
        data-testid="exitModal"
        isOpen={isExitModalOpen}
        onClose={onExitModalCloseHandler}
        shouldCloseOnBackdropClick={false}
      >
        <ModalHeading>{HEADER}</ModalHeading>
        <ModalContent>{isAuthenticated ? CONTENT_WITH_AUTH : CONTENT_WITHOUT_AUTH}</ModalContent>
        <ButtonWrapper>
          <Button
            id="formhero-exitmodal-cancel"
            onClick={() => onExitModalCloseHandler()}
            variant={BUTTON_VARIANT.SECONDARY}
          >
            {BUTTON_CANCEL}
          </Button>
          <Button
            id="formhero-exitmodal-exit"
            ariaLabel="exit the form"
            onClick={() => getData(bffRoutes.getLogout())}
            saving={data.isLoading}
            disabled={data.isLoading}
            disableClickEffect={true}
          >
            {BUTTON_EXIT}
          </Button>
        </ButtonWrapper>
      </Modal>
    </div>
  );
};

export default ExitModal;
